/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultNiveau } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_multi_010: Question = {
  id: 'multi-010-campagne-sensibilisation',
  oldId: '71',
  title: 'Campagne de sensibilisation à destination des citoyens',
  number: '7.2',
  description: [''],
  type: QuestionType.ACTIVITY,
  frequency: 1,
  idEM: 8,
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: false,
      scoringFct: (data: string[]) => parseFloat(data[0]),
      score: '0',
      maxScore: 1,
      help: defaultNiveau,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

const question_multi_010__v3: Question = {
  ...question_multi_010,
  title: 'Mise en oeuvre de campagnes visant la diminution de l\'utilisation de pesticides',
};

export const question_multi_010_v2: Question = question_multi_010;
export const question_multi_010_v3: Question = question_multi_010__v3;
